import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectionStrategy,
  input,
  model,
} from '@angular/core';
import { ImageSlide } from '../image-slider/models/image-slide';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'ag-modal-gallery',
  templateUrl: './modal-gallery.component.html',
  styleUrls: ['./modal-gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class ModalGalleryComponent implements OnInit {
  readonly images = input<Array<ImageSlide>>(new Array<ImageSlide>());
  readonly isOpen = model(false);

  private currentImage;

  constructor() {}

  ngOnInit() {
    this.currentImage = this.images()[0];
  }

  nextImage() {
    const currentIndex = this.images().findIndex(
      (v) => v.id === this.currentImage.id,
    );

    if (currentIndex + 1 > this.images().length - 1) {
      this.currentImage = this.images()[0];
      return;
    }

    this.currentImage = this.images()[currentIndex + 1];
  }

  previousImage() {
    const currentIndex = this.images().findIndex(
      (v) => v.id === this.currentImage.id,
    );

    if (currentIndex - 1 === -1) {
      this.currentImage = this.images()[this.images().length - 1];
      return;
    }

    this.currentImage = this.images()[currentIndex - 1];
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event) {
    if (this.isOpen()) {
      switch (event.key) {
        case 'Escape':
          this.close();
          break;

        case 'ArrowRight':
        case 'd':
          this.nextImage();
          break;

        case 'ArrowLeft':
        case 'a':
          this.previousImage();
          break;
      }
    }
  }

  close() {
    this.isOpen.set(false);
  }
}
